(function() {
  var isMobile = function() { return window.innerWidth < 750; };

  /* ═══════════════════════════════════════════════
     PRODUCT IMAGE SLIDER
  ═══════════════════════════════════════════════ */

  var pseImgState = {};

  function pseGetImgState(pid) {
    if (!pseImgState[pid]) {
      var wrap  = document.querySelector('.pse-card__img-wrap[data-pid="' + pid + '"]');
      var track = document.getElementById('pse-img-track-' + pid);
      var total = wrap ? parseInt(wrap.dataset.imgCount, 10) : 0;
      pseImgState[pid] = { current: 0, total: total, track: track, dragging: false };
    }
    return pseImgState[pid];
  }

  function pseImgRender(pid, idx, animate) {
    var s = pseGetImgState(pid);
    if (s.total < 1) return;
    idx = ((idx % s.total) + s.total) % s.total;
    s.current = idx;

    if (!animate) s.track.classList.add('no-transition');
    s.track.style.transform = 'translateX(-' + (idx * 100) + '%)';
    if (!animate) {
      s.track.offsetHeight;
      s.track.classList.remove('no-transition');
    }

    var dotsEl = document.getElementById('pse-img-dots-' + pid);
    if (dotsEl) {
      dotsEl.querySelectorAll('.pse-img-dot').forEach(function(d, i) {
        d.classList.toggle('active', i === idx);
      });
    }
  }

  window.pseImgSlide = function(pid, dir) {
    var s = pseGetImgState(pid);
    pseImgRender(pid, s.current + dir, true);
  };

  window.pseImgGoto = function(pid, idx) {
    pseImgRender(pid, idx, true);
  };

  /* ── Touch / Mouse drag on each image wrap ── */
  function initImgDrag(wrap) {
    var pid      = wrap.dataset.pid;
    var s        = pseGetImgState(pid);
    var startX   = 0;
    var startY   = 0;
    var diffX    = 0;
    var isDragging = false;
    var isVertical = false;
    var threshold  = 40;
    var DRAG_RESISTANCE = 0.3;

    function onStart(clientX, clientY) {
      if (s.total <= 1) return;
      startX     = clientX;
      startY     = clientY;
      diffX      = 0;
      isDragging = true;
      isVertical = false;
      s.track.classList.add('no-transition');
    }

    function onMove(clientX, clientY) {
      if (!isDragging) return;
      diffX = clientX - startX;
      var diffY = clientY - startY;

      if (!isVertical && Math.abs(diffY) > Math.abs(diffX) && (Math.abs(diffX) < 10 && Math.abs(diffY) > 5)) {
        isVertical = true;
      }
      if (isVertical) { isDragging = false; s.track.classList.remove('no-transition'); return; }

      var offset = -(s.current * 100);
      var drag   = (diffX / wrap.offsetWidth) * 100 * DRAG_RESISTANCE;
      var atStart = s.current === 0          && diffX > 0;
      var atEnd   = s.current === s.total - 1 && diffX < 0;
      var realDrag = (atStart || atEnd) ? drag * 0.3 : (diffX / wrap.offsetWidth) * 100;
      s.track.style.transform = 'translateX(' + (offset + realDrag) + '%)';
    }

    function onEnd() {
      if (!isDragging) return;
      isDragging = false;
      s.track.classList.remove('no-transition');
      if (Math.abs(diffX) > threshold) {
        pseImgRender(pid, s.current + (diffX < 0 ? 1 : -1), true);
      } else {
        pseImgRender(pid, s.current, true);
      }
    }

    wrap.addEventListener('touchstart', function(e) {
      onStart(e.touches[0].clientX, e.touches[0].clientY);
    }, { passive: true });
    wrap.addEventListener('touchmove', function(e) {
      onMove(e.touches[0].clientX, e.touches[0].clientY);
    }, { passive: true });
    wrap.addEventListener('touchend',   onEnd, { passive: true });
    wrap.addEventListener('touchcancel',onEnd, { passive: true });

    wrap.addEventListener('mousedown', function(e) {
      if (e.button !== 0) return;
      onStart(e.clientX, e.clientY);
      e.preventDefault();
    });
    window.addEventListener('mousemove', function(e) {
      if (!isDragging) return;
      onMove(e.clientX, e.clientY);
    });
    window.addEventListener('mouseup', function(e) {
      if (!isDragging) return;
      onEnd();
    });

    /* ── FIX 1: Product page navigate on click (uses data-product-url) ── */
    wrap.addEventListener('click', function(e) {
      /* If it was a real drag, cancel navigation */
      if (Math.abs(diffX) > 8) {
        e.preventDefault();
        diffX = 0;
        return;
      }

      /* If click was on interactive elements inside wrap, ignore */
      if (
        e.target.closest('.pse-img-arrow') ||
        e.target.closest('.pse-img-dot') ||
        e.target.closest('.pse-plus-btn') ||
        e.target.closest('.pse-size-inline')
      ) {
        return;
      }

      /* Navigate to product page */
      var card = wrap.closest('.pse-card');
      if (card && card.dataset.productUrl) {
        window.location.href = card.dataset.productUrl;
      }

      diffX = 0;
    });
  }

  /* ─── SECTION-LEVEL DESKTOP ARROW SCROLL ─── */
  window.pseScroll = function(sid, dir) {
    var track = document.getElementById('pse-track-' + sid);
    if (!track) return;
    var card = track.querySelector('.pse-card');
    if (!card) return;
    var cardW = card.offsetWidth + 8;
    track.scrollBy({ left: dir * cardW * 2, behavior: 'smooth' });
    setTimeout(function() { pseUpdateArrows(sid); }, 350);
  };

  function pseUpdateArrows(sid) {
    var track = document.getElementById('pse-track-' + sid);
    var prev  = document.getElementById('pse-prev-' + sid);
    var next  = document.getElementById('pse-next-' + sid);
    if (!track || !prev || !next) return;
    prev.classList.toggle('hidden', track.scrollLeft < 10);
    next.classList.toggle('hidden', track.scrollLeft + track.clientWidth >= track.scrollWidth - 10);
  }

  /* ─── SECTION-LEVEL MOBILE SLIDER DOTS ─── */
  function initMobileDots(sid) {
    var track    = document.getElementById('pse-track-' + sid);
    var dotsWrap = document.getElementById('pse-dots-' + sid);
    if (!track || !dotsWrap) return;
    if (!track.classList.contains('pse-track--mob-slider')) return;

    var cards = track.querySelectorAll('.pse-card');
    dotsWrap.innerHTML = '';
    cards.forEach(function(_, i) {
      var dot = document.createElement('button');
      dot.className = 'pse-dot' + (i === 0 ? ' active' : '');
      dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
      dot.addEventListener('click', function() {
        var cardW = cards[0].offsetWidth + 12;
        track.scrollTo({ left: i * cardW, behavior: 'smooth' });
      });
      dotsWrap.appendChild(dot);
    });

    track.addEventListener('scroll', function() {
      var dots = dotsWrap.querySelectorAll('.pse-dot');
      var idx  = Math.round(track.scrollLeft / (cards[0].offsetWidth + 12));
      dots.forEach(function(d, i) { d.classList.toggle('active', i === idx); });
    });
  }

  /* ─── Wire up a freshly-populated track (used for both initial load
         and after recommendations are injected) ─── */
  function initTrack(track) {
    var sid = track.id.replace('pse-track-', '');

    track.querySelectorAll('.pse-card__img-wrap').forEach(function(wrap) {
      initImgDrag(wrap);
    });

    if (track.classList.contains('pse-track--slider')) {
      track.addEventListener('scroll', function() { pseUpdateArrows(sid); });
      pseUpdateArrows(sid);
    }
    if (isMobile()) initMobileDots(sid);
  }

  /* ═══════════════════════════════════════════════
     AUTOMATIC PRODUCT RECOMMENDATIONS
     Fetches this same section rendered through Shopify's
     recommendations endpoint, then swaps the resulting
     product cards into the (currently empty) track.
     Shopify's engine already excludes the viewed product
     and never returns duplicates.
  ═══════════════════════════════════════════════ */
  function loadRecommendations(sectionEl) {
    var url = sectionEl.dataset.pseRecoUrl;
    if (!url) return;

    fetch(url)
      .then(function(res) {
        if (!res.ok) throw new Error('Recommendations request failed');
        return res.text();
      })
      .then(function(html) {
        var parser = new DOMParser();
        var doc    = parser.parseFromString(html, 'text/html');
        var newTrack = doc.querySelector('.pse-track');
        var ownTrack = sectionEl.querySelector('.pse-track');
        if (!newTrack || !ownTrack) return;

        /* Extra safety dedupe on top of Shopify's own de-duping,
           in case of any overlap between multiple sections/sources */
        var seen = {};
        Array.prototype.slice.call(newTrack.querySelectorAll('.pse-card')).forEach(function(card) {
          var pid = card.dataset.productId;
          if (pid && seen[pid]) {
            card.remove();
          } else if (pid) {
            seen[pid] = true;
          }
        });

        if (!newTrack.querySelector('.pse-card')) {
          /* No recommendations available — hide the section rather
             than showing an empty block */
          sectionEl.style.display = 'none';
          return;
        }

        ownTrack.innerHTML = newTrack.innerHTML;
        initTrack(ownTrack);
      })
      .catch(function(err) {
        console.error('[PSE Recommendations]', err.message);
        sectionEl.style.display = 'none';
      });
  }

  /* ─── DOM READY ─── */
  document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.pse-track').forEach(function(track) {
      initTrack(track);
    });

    document.querySelectorAll('[data-pse-reco="true"]').forEach(function(sectionEl) {
      loadRecommendations(sectionEl);
    });
  });

  /* ─── BUILD SIZE BUTTONS ─── */
  function buildSizes(card, container, onSelectCallback) {
    container.innerHTML = '';
    var variantsData = JSON.parse(card.dataset.variants || '[]');
    var optionsData  = JSON.parse(card.dataset.options  || '[]');
    var sizeOptIdx   = 0;
    optionsData.forEach(function(opt, i) { if (/size/i.test(opt.name)) sizeOptIdx = i; });

    var seen = {};
    variantsData.forEach(function(v) {
      var sizeVal = v.options[sizeOptIdx];
      if (seen[sizeVal]) return;
      seen[sizeVal] = true;
      var btn = document.createElement('button');
      btn.className = 'pse-size-btn' + (v.available ? '' : ' unavail');
      btn.textContent = sizeVal;
      btn.dataset.variantId = v.id;
      btn.dataset.price     = v.price;
      btn.disabled = !v.available;
      if (onSelectCallback) {
        btn.addEventListener('click', function() {
          if (btn.classList.contains('unavail')) return;
          onSelectCallback(btn);
        });
      }
      container.appendChild(btn);
    });
  }

  /* ─── DESKTOP INLINE PICKER ─── */
  window.pseOpenPicker = function(plusBtn) {
    if (isMobile()) { pseOpenSheet(plusBtn); return; }

    var card    = plusBtn.closest('.pse-card');
    var pid     = card.dataset.productId;
    var panel   = document.getElementById('pse-inline-' + pid);
    var sizesEl = document.getElementById('pse-sizes-' + pid);

    document.querySelectorAll('.pse-size-inline.open').forEach(function(p) {
      if (p !== panel) {
        p.classList.remove('open');
        var op = p.closest('.pse-card').querySelector('.pse-plus-btn');
        if (op) op.classList.remove('active');
      }
    });

    var isOpen = panel.classList.contains('open');
    panel.classList.toggle('open', !isOpen);
    plusBtn.classList.toggle('active', !isOpen);

    if (!isOpen) {
      buildSizes(card, sizesEl, function(sizeBtn) {
        /* Auto-add to cart on size click */
        var variantId = parseInt(sizeBtn.dataset.variantId);
        sizeBtn.classList.add('adding');
        var proxyBtn = { textContent: '', disabled: false };
        pseAddToCart(variantId, proxyBtn, function() {
          panel.classList.remove('open');
          plusBtn.classList.remove('active');
        });
      });
    }
  };

  window.pseClosePicker = function(pid) {
    var panel   = document.getElementById('pse-inline-' + pid);
    var card    = panel && panel.closest('.pse-card');
    var plusBtn = card && card.querySelector('.pse-plus-btn');
    if (panel)   panel.classList.remove('open');
    if (plusBtn) plusBtn.classList.remove('active');
  };

  /* ─── MOBILE BOTTOM SHEET ─── */
  var _sheetCard = null;

  window.pseOpenSheet = function(plusBtn) {
    _sheetCard  = plusBtn.closest('.pse-card');
    var overlay = document.getElementById('pse-sheet-overlay');
    var titleEl = document.getElementById('pse-sheet-title');
    var priceEl = document.getElementById('pse-sheet-price');
    var sizesEl = document.getElementById('pse-sheet-sizes');
    var atcBtn  = document.getElementById('pse-sheet-atc');

    titleEl.textContent = _sheetCard.dataset.productTitle;
    priceEl.textContent = _sheetCard.dataset.productPrice;
    atcBtn.textContent  = 'Select a size';
    atcBtn.disabled     = true;

    /* ── FIX 2: Pass select callback to buildSizes so .selected class is added ── */
    buildSizes(_sheetCard, sizesEl, function(sizeBtn) {
      /* Remove selected from all siblings */
      sizesEl.querySelectorAll('.pse-size-btn').forEach(function(b) {
        b.classList.remove('selected');
      });
      /* Mark this one selected */
      sizeBtn.classList.add('selected');
      /* Enable ATC button and update price */
      atcBtn.disabled = false;
      atcBtn.textContent = 'ADD TO CART';
      priceEl.textContent = sizeBtn.dataset.price;
    });

    overlay.classList.add('open');
    document.body.style.overflow = 'hidden';
  };

  window.pseCloseSheet = function(e) {
    if (e && e.target !== document.getElementById('pse-sheet-overlay')) return;
    document.getElementById('pse-sheet-overlay').classList.remove('open');
    document.body.style.overflow = '';
    _sheetCard = null;
  };

  window.pseSheetAtc = function() {
    if (!_sheetCard) return;
    var sizesEl = document.getElementById('pse-sheet-sizes');
    var selBtn  = sizesEl.querySelector('.pse-size-btn.selected');
    if (!selBtn) return;
    var atcBtn = document.getElementById('pse-sheet-atc');
    pseAddToCart(parseInt(selBtn.dataset.variantId), atcBtn, function() {
      setTimeout(function() {
        document.getElementById('pse-sheet-overlay').classList.remove('open');
        document.body.style.overflow = '';
        _sheetCard = null;
      }, 800);
    });
  };

  /* ─── ADD TO CART ─── */
  window.pseAddToCart = function(variantId, btn, onSuccess) {
    if (!variantId) return;

    var originalText = btn.textContent.trim();
    btn.textContent  = 'Adding...';
    btn.disabled     = true;

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method:  'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body:    JSON.stringify({ id: variantId, quantity: 1 })
    })
    .then(function(res) {
      if (!res.ok) return res.json().then(function(e) { throw new Error(e.description || 'Add failed'); });
      return res.json();
    })
    .then(function() {
      return fetch(window.Shopify.routes.root + 'cart.js', {
        headers: { 'Accept': 'application/json' }
      }).then(function(r) { return r.json(); });
    })
    .then(function(cart) {
      var cartSummary = {
        id:            cart.token,
        totalQuantity: cart.item_count,
        cost: {
          totalAmount: {
            amount:       (parseFloat(cart.total_price) / 100).toFixed(2),
            currencyCode: cart.currency
          }
        },
        lines: (cart.items || []).map(function(item) {
          return {
            id:       String(item.key || item.id),
            quantity: item.quantity,
            cost: {
              totalAmount: {
                amount:       (parseFloat(item.final_line_price) / 100).toFixed(2),
                currencyCode: cart.currency
              }
            }
          };
        })
      };

      var resolveUpdate;
      var updatePromise = new Promise(function(resolve) { resolveUpdate = resolve; });

      var linesUpdateEvent = new CustomEvent('shopify:cart:lines-update', {
        bubbles: true, cancelable: true,
        detail:  { action: 'add', context: 'standard-action' }
      });
      linesUpdateEvent.promise = updatePromise;
      linesUpdateEvent.action  = 'add';

      document.dispatchEvent(linesUpdateEvent);
      resolveUpdate({ cart: cartSummary, detail: { itemCount: cart.item_count } });

      document.querySelectorAll('cart-icon').forEach(function(el) {
        if (typeof el.renderCartBubble === 'function') {
          el.renderCartBubble(cart.item_count);
        }
      });

      setTimeout(function() {
        var drawer = document.getElementById('cart-drawer');
        if (drawer && typeof drawer.open === 'function' && !drawer.hasAttribute('open')) {
          drawer.open();
        }
      }, 120);

      btn.textContent = 'Added!';
      setTimeout(function() { btn.textContent = originalText; btn.disabled = false; }, 1600);
      if (onSuccess) onSuccess();
    })
    .catch(function(err) {
      console.error('[PSE Cart]', err.message);
      btn.textContent = 'Error — Retry';
      setTimeout(function() { btn.textContent = originalText; btn.disabled = false; }, 2200);
    });
  };

})();